// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-service-card-new {
  background: #fff;
  height: 385px;
  padding: 1rem;
  border-radius: 12px;
  margin-bottom: 2.5rem;
  transition: 0.5s;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.custom-service-card-new .custom-service-card-header {
  background: rgba(53, 78, 128, 0.9);
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);
}
.custom-service-card-new .custom-service-card-header img {
  width: 85px;
  height: 100px;
  object-fit: contain;
}
.custom-service-card-new .custom-service-card-body {
  height: calc(300px - 1rem - 200px);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-service-card-new .custom-service-card-body .service-name {
  font-weight: 500;
  font-size: 1.1rem;
  color: #08245A;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.custom-service-card-new:hover {
  transform: translateY(-10px);
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/adminPages/home/serviceCard.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;AACF;AACE;EACE,kCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kDAAA;AACJ;AACI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AACN;AAIE;EACE,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAII;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;AAFN;AAME;EACE,4BAAA;EACA,2FAAA;AAJJ","sourcesContent":[".custom-service-card-new {\r\n  background: #fff;\r\n  height: 385px;\r\n  padding: 1rem;\r\n  border-radius: 12px;\r\n  margin-bottom: 2.5rem;\r\n  transition: 0.5s;\r\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n\r\n  .custom-service-card-header {\r\n    background: rgba(53, 78, 128, 0.90);\r\n    height: 200px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 12px;\r\n    clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);\r\n\r\n    img {\r\n      width: 85px;\r\n      height: 100px;\r\n      object-fit: contain;\r\n      //filter: brightness(0) invert(1);\r\n    }\r\n  }\r\n\r\n  .custom-service-card-body {\r\n    height: calc(300px - 1rem - 200px);\r\n    text-align: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    .service-name {\r\n      font-weight: 500;\r\n      font-size: 1.1rem;\r\n      color: #08245A;\r\n      font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    transform: translateY(-10px);\r\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
